export default __webpack_public_path__ + "static/media/QR.101dd7b3.jpg";